import request from '@/util/request';

// 出库单分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/warehouse/outbound/page', Object.assign({}, options, { params }));

// 出库单详情
export const getDetailApi = (params, options) =>
  request.get('/api/v4ward/warehouse/outbound/detail', Object.assign({}, options, { params }));

// 新增出库单
export const addApi = (params, options) =>
  request.post('/api/v4ward/warehouse/outbound/submit', params, options, {
    'Content-Type': 'application/json',
  });

// 新增出库的导入模板
export const uploadExcelMaterialApi = (params, options) =>
  request.post('/api/v4ward/warehouse/outbound/uploadExcelMaterial', params, options);

// 获取调拨单列表
export const getTransferOrderListApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/outbound/getAllotOutboundInformation',
    Object.assign({}, options, { params })
  );

// 根据调拨单获取物料列表
export const getTransferGoodsListByIdApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/outbound/getAllotOutboundMaterialInformation',
    Object.assign({}, options, { params })
  );

// 获取领用申请单列表
export const getUseOrderListApi = (params, options) =>
  request.get('/api/v4ward/warehouse/outbound/getRequisitionOutboundInformation', Object.assign({}, options, { params }));

// 根据领用申请单获取物料列表
export const getUseGoodsListByIdApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/requisition/consumable/getConsumableListByRequisitionId',
    Object.assign({}, options, { params })
  );
